import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const RegForm = () => {
  // const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
      const res = await axios.post(`${apiUrl}/auth/register`, { email, password });
      setMessage(res.data.message || 'Sikeres regisztráció! Kérjük, nézd meg az emailed, és kattints a megerősítő linkre.');
      // Nem mentünk tokent, nem navigálunk tovább, amíg nincs megerősítés
    } catch (error) {
      setMessage(error.response?.data?.error || 'Hiba történt');
    }
  };

  return (
    <div>
      <h2>Regisztráció</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Jelszó"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit">Regisztrálj</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default RegForm;